<template>
  <div
  id="inbox"
  class="page page-on-center close-picker"
  data-page="inbox-page" @ptr:refresh="onRefresh(false)">

  <div class="showSmallScreenOnly" v-bind:class="colorBottomButton">
    <f7-fab class="leftfav button-fab bottomButton floatingButtonToolbarBlank" @click="extractCSV(inboxMessages)">
      <f7-icon f7="document_text"></f7-icon>
    </f7-fab>
  </div>

  <div class="page-content infinite-scroll"
  style="z-index:9"
  @infinite="onInfinite">

    <div class="pull-to-refresh-layer">
      <div class="preloader"></div>
      <div class="pull-to-refresh-arrow"></div>
    </div>

    <page-nav-bar
      :currentServiceName="serviceName"
      popoverName=".popoverInbox"
      :subNavTitle="$t('common.received_reqsts')"
      :menuAccess="true"
      :paymentsNumber="paymentsNumber">
    </page-nav-bar>

    <div class="row rowBackgroundImage showLargeScreenOnly" v-bind:class="colorBottomButton">
      <button class="milkyBlock boxRequest pull-right" @click="extractCSV(inboxMessages)">
        <f7-icon f7="document_text"></f7-icon>
        <span class="fab-label">{{ $t('common.extract_csv') }}</span>
      </button>
    </div>

    <div class="searchForm">
      <cm-messages-filter
        class="researchfilter"
        style="position:relative;z-index:10"
        :isPayments="true"
        :received="true">
      </cm-messages-filter>

  		<transactions-list
        :filterBy="filterBy"
        v-bind:inMessages="inboxMessages">
      </transactions-list>

      <cm-pagination
        :firstIndex="paginationObject.firstIndex"
        :maxResultsByPage="paginationObject.maxResults"
        :nbResultsTotal="paginationObject.nbResultsTotal"
        :refreshEvent="paginationObject.refresh">
      </cm-pagination>
      <div class="toolbarPageBottomBlank"></div>
    </div>
  </div>
</div>
</template>

<script>
import {errorMessageAlert} from '@/helpers/alert'
import TransactionsList from '@/pages/requests/TransactionsList.vue'
import MessagesFilter from '@/components/common/Filter.vue'
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import pagination from '@/components/common/pagination.vue'
import moment from 'moment'
import {statusLabel} from '@/helpers/labels'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'Inbox',
  components: {
    'page-nav-bar': pageNavBar,
    'transactions-list': TransactionsList,
    'cm-messages-filter': MessagesFilter,
    'cm-pagination': pagination,
    'bottom-toolbar': bottomToolbar
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      serviceName: this.$t('common.appname'),
      inboxMessages: [],
      inboxDir: 0,
      pageCounter: 0,
      noMoreMessages: false,
      newRequest: 1,
      scrollDown: false,
      filterBy: '',
      afterBack: false,
      paymentsNumber: '',
      noMore: false,
      scrollFlag: true,
      paginationObject: {}
    }
  },
  created () {
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 10
    this.paginationObject['nbResultsTotal'] = 0
    this.paginationObject['refresh'] = 'inbox-filtered'
    let that = this
    this.$f7.params.swipePanel = that.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    this.$f7.params.panelsCloseByOutside = that.$engine.services.directPayments.filter.smartphoneStorage
    this.$engine.settings.set({msgDirection: 0})
    this.$bus.$off('refresh-cache-contacts')
    this.$bus.$off('refresh-inbox-on-seen')
    this.$bus.$off('inbox-filtered')
    this.$bus.on('refresh-inbox-on-seen', (refPays) => {
      that.updateInbox(refPays, true)
      loadPage(that, {url: '/payments/transaction-details/'})
    })
    this.$bus.$on('inbox-filtered', index => {
      that.onRefresh(false, index)
      that.pageCounter = 0
    })
    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    if (this.$engine.user.getIsFirstLogin() === '1') {
      this.$engine.user.setIsFirstLogin('0')
      that.$f7.openPanel('left')
      that.$engine.services.payments.getPaymentsNotReadNumber()
      .then(resp => {
        if (resp.data.requestNotReadNumber > 99) {
          that.Dom7('.numberBadge').text('99+')
        } else {
          that.Dom7('.numberBadge').text(resp.data.requestNotReadNumber)
        }
      })
      .catch(error => {
        console.log(error)
      })
    }
    this.onRefresh(true)
  },
  beforeDestroy () {
    let that = this
    this.$f7.onPageAfterBack('details-page', function (page) {}).remove()
    that.$engine.services.payments.filter.cleanFilterCondition()
  },
  computed: {
    emptyBox () {
      return this.inboxMessages.length === 0
    }
  },
  methods: {
    detachInfinit () {
      this.$$('.infinite-scroll-preloader').remove()
      this.$f7.detachInfiniteScroll(this.$$('.infinite-scroll'))
      this.$engine.settings.set({inboxPreloaderRemoved: true})
      if (!this.emptyBox) this.scrollFlag = false
    },
    attachInfinit () {
      if (this.$settings.inboxPreloaderRemoved) {
        this.$$('.infinite-scroll').append(
        '<div class="infinite-scroll-preloader"><div class="preloader"></div></div>'
        )
        this.$f7.attachInfiniteScroll(this.$$('.infinite-scroll'))
        this.$engine.settings.set({inboxPreloaderRemoved: false})
      }
      this.scrollFlag = true
    },
    onInfinite: function (event) {
      if (this.scrollFlag) {
        this.scrollFlag = false
        let that = this
        that.pageCounter = that.pageCounter + 1

        that.$engine.services.payments.update(0, this.paginationObject.maxResults, this.paginationObject.firstIndex, that.$engine.services.payments.filter.getConditionObject())
        .then(resp => {
          this.paginationObject.nbResultsTotal = resp.data.totalPayments
          this.paymentsNumber = resp.data.totalPayments
          let payments = resp.data.payments
          if (payments.length > 0) {
            for (let i = 0; i < payments.length; i++) {
              that.inboxMessages.push(payments[i])
            }
            if (payments.length < 15) {
              that.detachInfinit()
            }
          } else {
            that.detachInfinit()
          }
          this.scrollFlag = true
        })
        .catch(error => {
          errorMessageAlert(error, that)
          this.scrollFlag = true
        })
      }
    },
    onRefresh: function (noAttach, index = 1) {
      const that = this
      this.pageCounter = 0
      this.scrollFlag = true
      this.paginationObject.firstIndex = index
      that.$engine.services.payments.update(0, this.paginationObject.maxResults, this.paginationObject.firstIndex, that.$engine.services.payments.filter.getConditionObject())
      .then(resp => {
        this.paginationObject.nbResultsTotal = resp.data.totalPayments
        this.paymentsNumber = resp.data.totalPayments
        this.updateInbox(resp.data.payments, noAttach)
        that.$f7.pullToRefreshDone()
        // that.$f7.hidePreloader()
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
      // that.$engine.services.payments.update(0, 15, 1,
      //   {
      //     status: that.$engine.services.payments.filter.status,
      //     dateBegin: that.$engine.services.payments.filter.dateBegin,
      //     dateEnd: that.$engine.services.payments.filter.dateEnd,
      //     cdtrOrDbtrNm: that.$engine.services.payments.filter.creditorOrDebtorName,
      //     negotiationStatus: that.$engine.services.payments.filter.negotiationStatus
      //   }
      // )
      // .then(resp => {
      //   this.paymentsNumber = resp.data.totalPayments
      //   this.updateInbox(resp.data.payments, noAttach)
      //   that.$f7.pullToRefreshDone()
      //   // that.$f7.hidePreloader()
      // })
      // .catch(error => {
      //   errorMessageAlert(error, that)
      // })
    },
    updateInbox (payments, noAttach = false) {
      this.inboxMessages = payments
      if (payments.length === 15) {
        if (!noAttach) {
          this.attachInfinit()
        }
      } else {
        this.detachInfinit()
      }
    },
    onSearch (query, found) {
      this.filterBy = query
    },
    onClear: function (event) {
      this.filterBy = ''
      this.attachInfinit()
    },
    onEnable: function (event) {
      this.detachInfinit()
    },
    onDisable: function (event) {
      this.attachInfinit()
    },
    OpenFormsPage () {
      const that = this
      that.$f7.popup('.forms-page')
    },
    extractCSV (inboxMessages) {
      let firstLine = this.$t('common.status.id') + ';' + this.$t('common.status.status_label') + ';' +
        this.$t('common.rsn') + ';' + this.$t('attachments.id') + ';' + this.$t('common.crdtr_name') + ';' +
        this.$t('common.date_label') + '\r\n'

      let lines = ''
      for (let datas in inboxMessages) {
        lines += inboxMessages[datas]['status'] + ';' +
        statusLabel(this.$i18n, inboxMessages[datas]['status'], inboxMessages[datas]['negotStatus'], 0) + ';' +
        inboxMessages[datas]['remittanceInformation'] + ';' +
        inboxMessages[datas]['attachmentId'] + ';' +
        inboxMessages[datas]['creditorName'] + ';' +
        inboxMessages[datas]['creationDate'] + '\r\n'
      }

      let data = firstLine + lines

      const linkSource = 'data:text/csv;charset:utf-8,' + data
      const downloadLink = document.createElement('a')
      let today = moment()
      const fileName = 'receivedRequestToPay' + today.unix() + '.csv'

      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    }
  }
}
</script>

<style>
.rowBackgroundImage {
  background-image: url('../../../assets/static/images/MenuFont.png');
  background-size: contain;
}
</style>



// WEBPACK FOOTER //
// CMInboxPage.vue?1a1f7e03